import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import CryptoES from 'crypto-es';
import { ScriptsIds } from 'src/app/domain/models/scripts/scripts-ids';

@Injectable({
    providedIn: 'root'
})
export class ScriptService {

    private readonly SCRIPTS_WITHOUT_SRI = new Set(['boardwalk-script', 'horizon-script', 'google-maps-script', 'mx-connect-script']);
    private readonly SCRIPTS_WITH_KNOWN_INTEGRITY: Record<string, string> = {};

    constructor(private http: HttpClient) { }

    public loadScript(id: string, url: string, options?: { skipIntegrity?: boolean }) {

        return new Promise(async (resolve, reject) => {
            if (id && document.getElementById(id)) {
                resolve({ id: id, loaded: true, status: 'Already Loaded' });
                return;
            }
            if (id === ScriptsIds.GoogleMaps && (window as any).google?.maps) {
                resolve({ id: id, loaded: true, status: 'Already Loaded' });
                return;
            }
            let integrityAttribute: string | undefined;
            // Per-token vendor URLs can't be pinned to a hash; CSP script-src still applies.
            const skipIntegrity = !!options?.skipIntegrity || this.SCRIPTS_WITHOUT_SRI.has(id);
            let shouldInsert = skipIntegrity;

            if (!shouldInsert) {
                if (this.SCRIPTS_WITH_KNOWN_INTEGRITY[id]) {
                    integrityAttribute = this.SCRIPTS_WITH_KNOWN_INTEGRITY[id];
                    shouldInsert = true;
                } else {
                    console.warn(`[ScriptService] double-download fallback for "${id}": fetching to compute SRI hash`);
                    const scriptContent = await firstValueFrom(this.http.get(url, { responseType: 'text' }));
                    integrityAttribute = CryptoES.SHA384(scriptContent).toString(CryptoES.enc.Base64);
                    shouldInsert = scriptContent != undefined;
                }
            }

            if (shouldInsert) {
                const body = document.body;
                let script = document.createElement('script');
                if (!skipIntegrity) {
                    script.type = 'text/javascript'
                }
                script.innerHTML = '';
                script.src = url;
                if(id != "horizon-script") {
                    script.id = id;
                    script.async = true;
                } else {
                    script.defer = true;
                }
                if (!skipIntegrity){
                    script.integrity = `sha384-${integrityAttribute}`;
                    script.crossOrigin = "anonymous";
                }
                script.onload = (r) => {
                    return resolve({ id: id, loaded: true, status: 'Loaded' });
                };
                script.onerror = (error: any) => resolve({ id: id, loaded: false, status: 'Loaded' });
                body.appendChild(script);
            }
        });
    }

    public removeScript(id: string) {
        let script = document.getElementById(id);
        if (script) {
            script.remove();
        }
    }
}
